/* unplugin-vue-components disabled */import script from "./PBSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./PBSpinner.vue?vue&type=script&setup=true&lang=js"

import "./PBSpinner.vue?vue&type=style&index=0&id=9804585c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9804585c"]])

export default __exports__